import * as yup from 'yup';

const validationSchema = formatMessage =>
  yup.object({
    claimsStatus: yup.bool().typeError(
      formatMessage({
        id: 'CLAIMS_STATUS_IS_REQUIRED',
        defaultMessage: 'Claims Status is required',
      }),
    ),
  });

export default validationSchema;
